//宏创控股
import Overview from '@rebuild/materials/shared/question/Overview.vue';
import Full from '@rebuild/materials/shared/question/FullIndex.vue';
import MobFull from '@rebuild/materials/shared/question/mobile/MobFullIndex.vue';
import MobOverview from '@rebuild/materials/shared/question/mobile/MobOverview.vue';
import MobDetail from '@rebuild/materials/shared/question/mobile/MobDetail.vue';

import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/question/context';

function useSelfContext() {
    provideCurrentContext({
        showTabs: false
    });
}

export const componentMap = {
	overview: Overview,
	full: withProvider(Full, useSelfContext),
	'mob-overview': MobOverview,
	'mob-full': withProvider(MobFull, useSelfContext),
	'mob-detail': MobDetail
}; 